import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { AssembliesList } from "./AssembliesList";

const AssembliesBase = () => {
    const { t } = useTranslation();
    const { navStore, assemblyStore } = useContext(RootStoreContext);

    useEffect(() => {
        navStore.setTitle(t("screens.assemblies.sidebar_title"));
        navStore.setActionButtonMiddle(null);
        navStore.setActionButtonRight(null);
        navStore.setBackbutton(null);
    }, [navStore, t]);

    useEffect(() => {
        assemblyStore.loadAllAssemblies(undefined);
        // eslint-disable-next-line
    }, []);

    return <AssembliesList realestateId={undefined} />;
};

export const Assemblies = Sentry.withProfiler(observer(AssembliesBase));
